import React, { PureComponent } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { withRouter, RouteComponentProps } from 'react-router';

import { PanelSection, Text, Grid, GridColumn } from '../../../core/components/styled';
import { loadRecurringServices } from '../../ducks/recurringServices';
import pricingInfoIntialValueSelector from '../../services/pricingInfoIntialValueSelector';
import translate from '../../../core/services/translate';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface ComponentProps extends RouteComponentProps<RouteParams> {
  vendorId: number;
}

interface PropsWithoutReduxForm extends ComponentProps {
  pricingInfo: any;
  initialValues: any;
  loadRecurringServices(...args: any[]): any;
}

type Props = PropsWithoutReduxForm & InjectedFormProps<any, PropsWithoutReduxForm>;

class PricingInfoForm extends PureComponent<Props> {
  handleSubmit = async (event: any) => {
    const { match, vendorId } = this.props;
    const token = match.params.token;
    const date = moment(event).format('MM/DD/YYYY');

    await this.props.loadRecurringServices(vendorId, token, date);
  };

  render() {
    const { pricingInfo } = this.props;

    return (
      <form onSubmit={this.handleSubmit} noValidate>
        <PanelSection centered withBorder padding="sMedium">
          <Grid padding="no small no no" multiLine>
            {/* <OpportunityInfoIcon color="primary" margin="xSmall xSmall xxSmall" /> */}

            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block weight="medium" margin="no no xxSmall">
                  {translate('Recurring Services Total')}:
                </Text>
                <Text block weight="medium" margin="no xSmall xxSmall">
                  ${pricingInfo.recurringServicesTotal}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block weight="medium" margin="no no xxSmall">
                  {translate('On-Call Services Total')}:
                </Text>
                <Text block weight="medium" margin="no xSmall xxSmall">
                  ${pricingInfo.onCallServiceTotal}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block weight="medium" margin="no no xxSmall">
                  {translate('Grand Total')}:
                </Text>
                <Text block weight="medium" margin="no xSmall xxSmall">
                  ${pricingInfo.grandTotal}
                </Text>
              </PanelSection>
            </GridColumn>

            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('Recurring Services Total Unpaid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  ${pricingInfo.recurringServicesTotalUnPaid}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('On-Call Services Total Unpaid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  ${pricingInfo.onCallServicesTotalUnPaid}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('Total Unpaid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  ${pricingInfo.totalUnPaid}
                </Text>
              </PanelSection>
            </GridColumn>

            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('Recurring Services Total Paid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  ${pricingInfo.recurringServicesTotalPaid}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('On-Call Services Total Paid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  ${pricingInfo.onCallServicesTotalPaid}
                </Text>
              </PanelSection>
            </GridColumn>
            <GridColumn padding="no no no" size="4/12" align="left">
              <PanelSection>
                <Text block margin="no no xxSmall" weight="light" size="small">
                  {translate('Total Paid')}:
                </Text>
                <Text block margin="no xSmall xxSmall" weight="light" size="small">
                  $ {pricingInfo.totalPaid}
                </Text>
              </PanelSection>
            </GridColumn>
          </Grid>
        </PanelSection>
      </form>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  //   workOrdersInfo: state.payments.recurringServices.workOrdersInfo,
  pricingInfo: state.payments.recurringServices.pricingInfo,
  initialValues: pricingInfoIntialValueSelector(state.payments.recurringServices.pricingInfo),
});

const mapDispatchToProps = { loadRecurringServices };

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm<any, PropsWithoutReduxForm>({
      form: 'pricingInfoForm',
      enableReinitialize: true,
    })(PricingInfoForm),
  ),
);
